module.exports = __webpack_public_path__ + "static/media/_default-inky.fe4ae2e9.png";